(() => {
  if (customElements.get('content-with-products')) {
    return;
  }

  class ContentWithProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();

      document.addEventListener(
        'hardware-images:load',
        this.changeHardwareImages.bind(this),
      );
    }

    init() {
      if (!this.hasAttribute('data-lazyload-blocks')) {
        return;
      }

      this.itemsContainer = this.querySelector('[data-items]');
      this.loaderContainer = this.querySelector('[data-loader]');
      this.blocksCount =
        this.itemsContainer?.querySelectorAll('[data-item]')?.length || 0;
      this.blocksAll = parseInt(this.dataset.blocksCount);
      this.url = this.dataset.url;

      this.initIntersection();
    }

    initIntersection() {
      if (!this.loaderContainer) {
        return;
      }

      const handleIntersection = (entries) => {
        if (!entries[0].isIntersecting) return;
        if (this.classList.contains('is-loading')) {
          return;
        }

        this.fetchContent();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 400px 0px',
      });

      this.observer.observe(this.loaderContainer);
    }

    fetchContent() {
      this.classList.add('is-loading');

      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const section = html.querySelector('content-with-products');

          if (section) {
            this.appendItems(section);

            this.updateSectionData(section);

            if (this.blocksCount >= this.blocksAll) {
              this.removeLoader();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('is-loading');
        });
    }

    updateSectionData(section) {
      this.url = section.dataset.url;

      this.dataset.url = section.dataset.url;
      this.dataset.blocksOffset = section.dataset.blocksOffset;
      this.dataset.blocksLoaded = section.dataset.blocksLoaded;
    }

    removeLoader() {
      this.observer?.unobserve(this.loaderContainer);

      this.loaderContainer.remove();
    }

    appendItems(section) {
      const items = section.querySelectorAll('[data-item]');

      items.forEach((item) => this.itemsContainer.append(item));

      this.blocksCount += items.length;
    }

    changeHardwareImages() {
      const urlParams = new URLSearchParams(this.url);
      const variantParameterValue = Math.floor(Date.now() * Math.random());

      if (urlParams.has('lazyload-offset')) {
        urlParams.delete('lazyload-offset');
      }

      if (urlParams.has('variant')) {
        urlParams.delete('variant');
      }

      urlParams.set('variant', variantParameterValue);
      urlParams.set('load-only', this.dataset.blocksLoaded);

      const url = urlParams.toString();

      fetch(`?${url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHtml = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );

          changeHardwareImages(responseHtml);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  customElements.define('content-with-products', ContentWithProducts);
})();
